import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import MainVisual from './view/MainVisual';
import Introduction1 from './view/Introduction1';
import Introduction2 from './view/Introduction2';
import Introduction3 from './view/Introduction3';
import Contact from './view/Contact';

function App() {
  return (
    <>
      <Header/>
      <MainVisual/>
      <Introduction1/>
      <Introduction2/>
      <Introduction3/>
      <Contact/>
      <Footer/>
    </>
  );
}

export default App;
